export type IframeToastType = 'success' | 'info' | 'warning' | 'error';

export type IframeOutbound =
  | { type: 'enrichly:ready' }
  | { type: 'enrichly:bulkOrder'; url: string }
  | { type: 'enrichly:toast'; toastType: IframeToastType; message: string }
  | {
      type: 'navigation';
      pathname: string;
      search?: string;
      productHandle?: string;
      collectionHandle?: string;
    }
  | { type: 'resize'; height: number };

export interface IframeContextPayload {
  orgId?: string;
  collectionHandle?: string;
  contactId?: string;
  salesforceId?: string;
  primaryColor?: string;
  textColorOverride?: string;
  navbar?: string;
}

export interface IframeInboundContext {
  type: 'enrichly:context';
  context: IframeContextPayload;
}

/**
 * Parent asks the widget to step back through its own history.
 *
 * A cross-origin parent cannot touch `iframe.contentWindow.history` — reading
 * `.history` off a cross-origin Window throws a SecurityError — so the parent
 * delegates the traversal to the widget instead of performing it directly.
 */
export interface IframeInboundBack {
  type: 'enrichly:back';
}

export type IframeInbound = IframeInboundContext | IframeInboundBack;

export function isStandalone(): boolean {
  return window.self === window.top;
}

/** Returns true if a message was actually sent to a parent window. */
export function sendToParent(message: IframeOutbound): boolean {
  if (isStandalone()) return false;
  window.parent.postMessage(message, '*');
  return true;
}
